export const DEFAULT_MINIMUM_NOTICE_MINUTES = 5;
